module.exports = __webpack_public_path__ + "Roboto-Regular.081b11ebaca8ad30fd09.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Regular.woff
// module id = 103
// module chunks = 11